/* Click-to-copy email address in the footer.

   The address sits in the markup as plain text, so it is readable without JS —
   this only copies it and flashes the confirmation chip. The chip text lives in
   `data-copied-label` on the wrapper rather than here so it stays translatable. */
function footerEmail() {
    const wrapper = document.querySelector('.gh-footer-email');
    if (!wrapper) return;

    const button = wrapper.querySelector('.gh-footer-email-button');
    const address = wrapper.querySelector('.gh-footer-email-address');
    const chip = wrapper.querySelector('.gh-footer-email-copied');
    if (!button || !address || !chip) return;

    const label = wrapper.dataset.copiedLabel || 'Copied';
    const text = address.textContent.trim();
    let timer = null;

    const flash = function () {
        clearTimeout(timer);
        chip.textContent = label;
        wrapper.classList.add('is-copied');

        timer = setTimeout(function () {
            wrapper.classList.remove('is-copied');
            /* Emptying the region is what lets the next copy announce, but wait
               out the fade first or the text vanishes mid-transition. */
            timer = setTimeout(function () {
                chip.textContent = '';
            }, 200);
        }, 2000);
    };

    /* Pre-clipboard-API browsers, and any secure-context failure */
    const legacyCopy = function () {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();

        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (e) {
            copied = false;
        }

        document.body.removeChild(field);
        return copied;
    };

    /* Last resort: select the address so it can still be copied by hand rather
       than leaving the click with no visible effect at all. */
    const selectAddress = function () {
        const selection = window.getSelection();
        if (!selection) return;

        const range = document.createRange();
        range.selectNodeContents(address);
        selection.removeAllRanges();
        selection.addRange(range);
    };

    const fallback = function () {
        if (legacyCopy()) {
            flash();
        } else {
            selectAddress();
        }
    };

    button.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(flash, fallback);
            return;
        }
        fallback();
    });
}
